import { render } from "./OffersPage.vue?vue&type=template&id=51763a20"
import script from "./OffersPage.vue?vue&type=script&lang=js"
export * from "./OffersPage.vue?vue&type=script&lang=js"

import "./OffersPage.vue?vue&type=style&index=0&id=51763a20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__